<template>
  <div class="personalConter">
    <div
      class="header-tips"
      v-if="info.auditState == 4"
    >账户已被冻结</div>
    <div
      class="my-header flex-between"
      @click="goToSet"
    >
      <div class="head-portrait">
        <img
          :src="imgPrex + info.headpic"
          alt
        />
      </div>
      <div style="flex: 1;overflow: hidden;">
        <div class="flex-between">
          <span
            class="header-shopName van-ellipsis"
            @click="goToSet"
          >{{info.shopName}}({{info.name}})</span>
          <span class="header-data">
            个人资料
            <van-icon
              name="arrow"
              color="#1D1D1D"
            />
          </span>
        </div>
        <div class="header-address"><i class="iconfont icon-zitidian van-ellipsis">{{info.communityAddress}}</i></div>
      </div>
    </div>
    <div class="my-invite">
      <div class="invite-tips">
        <b style="color: #1D1D1D">累计邀请人数: <em>{{info.inviteNum}}</em>人</b>
      </div>
    </div>
    <div
      class="common"
      v-if="info.userType != 2"
    >
      <div class="flex-between">
        <div class="assets-item assets-item-amount">
          <p class="assets-item-val">¥{{info.totalAmount}}</p>
          <p class="assets-val">累计收益</p>
        </div>
        <router-link
          class="assets-item assets-item-amount line"
          tag="div"
          :to="{path:'/beSettled',query: {price: info.settlementAmount}}"
        >
          <p class="assets-item-val">¥{{info.settlementAmount}}</p>
          <p class="assets-val">未到账</p>
        </router-link>
        <router-link
          class="assets-item assets-item-amount line"
          tag="div"
          to="/finance"
        >
          <p class="assets-item-val">¥{{info.canWithdraw}}</p>
          <p class="assets-val">已到账</p>
        </router-link>
      </div>
    </div>
    <div class="common">
      <router-link
        tag="div"
        to="/order"
        class="assets-all van-hairline--bottom flex-between"
      >
        <span>销售业绩</span>
        <span class="see-details">
          查看详情
          <van-icon
            name="arrow"
            color="#999999"
          />
        </span>
      </router-link>
      <div class="flex-between">
        <router-link
          tag="div"
          to="/order"
          class="assets-item"
        >
          <p class="orders-val">¥{{info.salesAmount}}</p>
          <p class="orders-val-text">累计销量</p>
        </router-link>
        <router-link
          tag="div"
          to="/finance"
          class="assets-item line"
          v-if="info.userType != 2"
        >
          <p class="orders-val">¥{{info.todayAmount}}</p>
          <p class="orders-val-text">今日收益</p>
        </router-link>
        <router-link
          tag="div"
          to="/order"
          class="assets-item line"
        >
          <p class="orders-val">{{info.todayOrderNum}}</p>
          <p class="orders-val-text">今日订单量</p>
        </router-link>
        <router-link
          tag="div"
          :to="{path:'/order',query: {active: 2}}"
          class="assets-item line"
        >
          <p class="orders-val">{{info.waitingPickUpOrder}}</p>
          <p class="orders-val-text">提货订单</p>
        </router-link>
      </div>
    </div>
    <div class="common">
      <div class="assets-all van-hairline--bottom flex-between">
        <span>配送到家</span>
        <van-switch
          :value="deliveryState"
          size="25px"
          @input="switchInput"
        />
      </div>
      <div
        class="deliverySet flex-between"
        v-show="deliveryState"
        @click="showScope = true;setObj.scope = scope;"
      >
        <span>配送距离</span>
        <span style="color: #208FFF">{{scope}}km<i class="iconfont icon-xiugai"></i>
        </span>
      </div>
      <div
        class="deliverySet-explain"
        :style="{ color: deliveryState ? '#999999' : '#FA3534' }"
      >说明：您已{{deliveryState ? "开启" : "关闭"}}配送到家服务,用户将{{deliveryState ? "" : "不再"}}提供详细收货地址</div>
    </div>
    <div class="common">
      <div class="flex-wrap">
        <div
          class="tools-item"
          v-for="(item,index) in toolsList"
          :key="index"
          @click="goToDetails(item.url,item.title)"
        >
          <img
            :src="item.imageUrl"
            alt
          />
          <span class="tools-val">{{item.title}}</span>
          <i v-if="info.hasMsg == 1 && item.title == '售后'"></i>
        </div>
      </div>
    </div>
    <!-- 配送距离弹窗 -->
    <van-dialog
      v-model="showScope"
      show-cancel-button
      confirmButtonColor="#FF453E"
      cancelButtonColor="#1D1D1D"
      :before-close="beforeClose"
    >
      <van-field
        type="tel"
        class="deliverySet-field"
        v-model="setObj.scope"
        label="配送距离:"
        placeholder="请输入送货上门范围"
        :formatter="formatter"
        :error-message="message"
        @input="onInput"
      >
        <template #button>
          km
        </template>
      </van-field>
    </van-dialog>
  </div>
</template>

<script>
import { myShop, shopInfo, updateShopInfo, setDeliveryState, getDeliveryState } from "@/api/join";
export default {
  data() {
    return {
      info: {},
      toolsList: [{
        url: "",
        title: "扫码提货",
        imageUrl: require("../../assets/img/personal_scan.png"),
      }, {
        url: "/bankCard",
        title: "我的银行卡",
        imageUrl: require("../../assets/img/personal_card.png"),
      }, {
        url: "/manage",
        title: "副店长管理",
        imageUrl: require("../../assets/img/personal_com.png"),
      }, {
        url: "/afterSaleMsg",
        title: "售后",
        imageUrl: require("../../assets/img/personal_help.png"),
      }, {
        url: "/strategy",
        title: "社区店长攻略",
        imageUrl: require("../../assets/img/personal_strategy.png"),
      },
        // {
        //   url: "/setState",
        //   title: "设置",
        //   imageUrl: require("../../assets/img/personal_set.png"),
        // }
      ],
      setObj: {},
      scope: "",
      message: "",
      showScope: false,
      deliveryState: false,
    };
  },
  methods: {
    onInput(e) {
      // 限制范围[0,200]之间
      if (e > 200) {
        this.setObj.scope = e.slice(0, e.length - 1);
      }
    },
    formatter(value) {
      // 输入一位小数
      return value.replace(/[^\d.]/g, "").replace(/\.{2,}/g, ".").replace(/^(\-)*(\d+)\.(\d).*$/, "$1$2.$3");
    },
    beforeClose(action, done) {
      switch (action) {
        case 'confirm':
          if (this.setObj.scope * 1 < this.setObj.minScope * 1) {
            this.message = `最小配送距离不能低于${this.setObj.minScope}km`;
            done(false);
            return;
          }
          updateShopInfo(this.setObj).then((res) => {
            if (res.appStatus.errorCode == 0) {
              this.message = "";
              this.scope = this.setObj.scope;
              this.$toast("保存成功");
              done();
            }
          });
          break;
        case 'cancel':
          this.message = "";
          done()
          break;
      }
    },
    getDeliveryState(id) {
      getDeliveryState({
        csId: id,//社区店长id
      }).then((res) => {
        if (res.appStatus.errorCode == 0) {
          //res.content.deliveryState 0-否 1-是
          this.deliveryState = res.content.deliveryState == 0 ? false : true;
        }
      });
    },
    getSetDeliveryState(checked) {
      setDeliveryState({
        csId: this.setObj.communityShopId,//社区店长id
        deliveryState: checked ? "1" : "0" //配送到家状态 0-否 1-是
      }).then((res) => {
        if (res.appStatus.errorCode == 0) {
          this.deliveryState = checked;
        }
      });
    },
    switchInput(checked) {
      this.$dialog.alert({
        title: checked ? "开启配送到家" : "",
        message: checked ? "社区店长需配合用户需求，将商品送至用户收货地址" : "是否确定关闭配送到家服务",
        confirmButtonText: checked ? "确定开启" : "确定关闭",
        confirmButtonColor: "#1993FF",
        cancelButtonText: "取消",
        cancelButtonColor: "#1D1D1D",
        showCancelButton: true,
      }).then(() => {
        this.getSetDeliveryState(checked);
      });
    },
    shopInfo() {
      shopInfo({}).then((res) => {
        if (res.appStatus.errorCode == 0) {
          this.setObj = res.content;
          this.scope = this.setObj.scope;
          this.getDeliveryState(this.setObj.communityShopId);
        }
      });
    },
    goToDetails(src, title) {
      if (title == "扫码提货") {
        this.scanQRCode();
      } else {
        this.$router.push(src);
      }
    },
    goToSet() {
      this.$router.push({
        path: "/set",
      });
    },
    scanQRCode() {
      if (this.$store.getters.ambientType == 1) {
        window.Android.goQrCode();
      } else if (this.$store.getters.ambientType == 2) {
        window.webkit.messageHandlers.goQrCode.postMessage("");
      }
    },
    algorithm(arg1, arg2, flag) {
      let r1, r2, m, n;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      m = Math.pow(10, Math.max(r1, r2));
      //动态控制精度长度
      n = r1 >= r2 ? r1 : r2;
      if (flag) {
        return ((arg1 * m - arg2 * m) / m).toFixed(n);
      } else {
        return ((arg1 * m + arg2 * m) / m).toFixed(n);
      }
    },
  },
  activated() {
    myShop({
      leastOpenTime: localStorage.getItem("leastOpenTime") ? localStorage.getItem("leastOpenTime") : "2020-04-04 04:04:04",
    }).then((res) => {
      if (res.appStatus.errorCode == 0) {
        this.$store.commit(
          "user/SET_communityShopId",
          res.content.communityShopId
        );
        this.info = res.content;
        this.info.imageUrl = res.content.headpic;
        let price = this.algorithm(this.info.hadWithdraw, this.info.canWithdraw, false);
        let totalPrice = this.algorithm(price, this.info.feeAmount, false);
        // 累计收益totalAmount=hadWithdraw+canWithdraw+settlementAmount+feeAmount
        this.info.totalAmount = this.algorithm(totalPrice, this.info.settlementAmount, false);
        this.info.userType == 2 ? this.toolsList = this.toolsList.filter(item => item.title != "我的银行卡" && item.title != "副店长管理") : null;
        // 每次冻结后该弹窗只弹一次
        if (this.info.auditState == 4) {
          let flag = localStorage.getItem("frozen");
          if (!flag) {
            this.$dialog.alert({
              message: "您的社区店长账号已被冻结佣金仍<br/>可提现,如有疑问可以联系平台",
              confirmButtonText: "我知道了",
              confirmButtonColor: "#1993FF",
            })
              .then(() => {
                localStorage.setItem("frozen", true);
              });
          }
        } else {
          localStorage.removeItem("frozen");
        }
      }
    });
    this.shopInfo();
  },
  created() {
    // 暴露方法供APP调用返回提货人买家id
    window.getBuyerMemberId = (data) => {
      this.$router.push({
        path: "/userOrder",
        query: {
          memberId: data,
        },
      });
    };
  },
};
</script>

<style lang="scss" scoped>
.flex-wrap {
  display: flex;
  flex-wrap: wrap;
}
.personalConter {
  padding-bottom: 60px;
}
.header-tips {
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  font-weight: 800;
  color: #ff1310;
  text-align: center;
  background-color: #ffe9d5;
}
.my-header {
  margin: 10px 10px 0;
  .head-portrait {
    flex: 0 0 43px;
    height: 43px;
    margin-right: 7px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 50%;
    }
  }
  .header-shopName,
  .header-data {
    font-size: 14px;
    font-weight: 800;
  }
  .header-data {
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }
  .header-state {
    flex-shrink: 0;
    margin-left: 10px;
    padding: 0 2px;
    font-size: 11px;
    font-weight: 800;
    color: #ffffff;
    background: linear-gradient(90deg, #fb6a4a 0%, #ff0808 100%);
    border-radius: 2px;
  }
  .header-address {
    margin-top: 4px;
    font-size: 0;
    color: #208fff;
    .icon-zitidian {
      display: block;
      font-size: 12px;
    }
  }
}
.my-invite {
  width: 337px;
  margin: 10px auto 0;
  padding: 10px 7px 12px 12px;
  background-color: #ffffff;
  border-radius: 10px;
  .invite-tips {
    display: flex;
    flex-direction: column;
    font-size: 10px;
    b {
      font-size: 15px;
      color: #ff1310;
      position: relative;
      padding-left: 19px;
      &::after {
        content: "";
        position: absolute;
        top: 50%;
        left: 0;
        -webkit-transform: translate(0, -50%);
        transform: translate(0, -50%);
        width: 16px;
        height: 16px;
        background-image: url(../../assets/img/fire.png);
        background-size: 100%;
      }
    }
    span {
      margin-top: 2px;
    }
    em {
      color: #ff1310;
      font-style: normal;
    }
  }
}
.common {
  margin: 10px 10px 0;
  padding: 4px 10px;
  background-color: #ffffff;
  border-radius: 10px;
  .assets-all {
    height: 50px;
    line-height: 50px;
    font-size: 17px;
    font-weight: 800;
    color: #3e3e3e;
    .see-details {
      display: flex;
      align-items: center;
      font-size: 15px;
      font-weight: 400;
      color: #8d8d8d;
      i {
        font-size: 20px;
      }
    }
  }
  .assets-item {
    flex: 1;
    padding: 18px 0;
    text-align: center;
    .assets-item-val {
      font-size: 24px;
      font-weight: bold;
      color: #ff1310;
    }
    .assets-val {
      margin-top: 4px;
      font-size: 12px;
      color: #262626;
    }
    .orders-val {
      font-size: 17px;
      font-weight: 800;
    }
    .orders-val-text {
      margin-top: 4px;
      font-size: 12px;
      color: #8d8d8d;
    }
  }
  .assets-item-amount {
    padding: 23px 0;
  }
  .line {
    position: relative;
    &::before {
      content: "";
      width: 1px;
      height: 30px;
      position: absolute;
      background-color: #f4f4f4;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      z-index: 100;
    }
  }
  .tools-item {
    flex: 0 0 83.75px;
    height: 79px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    position: relative;
    img {
      width: 40px;
      height: 40px;
      display: block;
    }
    .tools-val {
      font-size: 12px;
      color: #333333;
    }
    i {
      width: 10px;
      height: 10px;
      position: absolute;
      top: 15px;
      right: 26px;
      border-radius: 50%;
      border: 1px solid #ffffff;
      background-color: #ff1310;
    }
  }
}
.deliverySet {
  height: 50px;
  padding: 0 15px;
  font-size: 16px;
  background-color: #f8f8f8;
  border-radius: 5px;
  i {
    margin-left: 15px;
    font-size: 15px;
    color: #c0c4cc;
  }
}
.deliverySet-explain {
  padding: 10px 0 8px;
  font-size: 12px;
}
.deliverySet-field {
  padding: 30px 14px;
}
</style>
<style scoped>
.deliverySet-field >>> .van-field__label {
  width: auto;
  height: 40px;
  line-height: 40px;
  margin-right: 5px;
  font-size: 15px;
  color: #1d1d1d;
}
.deliverySet-field >>> .van-field__control {
  padding: 7px 5px;
  border: 1px solid #b4b4b4;
  border-radius: 5px;
}
.deliverySet-field >>> .van-field__button {
  font-size: 15px;
  color: #1d1d1d;
}
.deliverySet-field >>> .van-field__error-message {
  position: absolute;
  top: 40px;
  font-size: 11px;
  color: #fd3325;
  z-index: 1000;
}
</style>